<template>
    <div class="flex flex-col items-center justify-center p-6 bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-900 rounded-2xl border border-blue-100 dark:border-gray-700 shadow-sm max-w-lg mx-auto mt-4 transition-all duration-300 hover:shadow-md">
        <!-- Shield Icon with Pulsing Effect -->
        <div class="relative flex items-center justify-center w-16 h-16 bg-blue-100 dark:bg-blue-900/30 rounded-full mb-4">
            <div class="absolute inset-0 rounded-full bg-blue-400/20 dark:bg-blue-500/20 animate-ping"></div>
            <svg class="w-8 h-8 text-blue-600 dark:text-blue-400 relative z-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
            </svg>
        </div>

        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-2 text-center">{{ $t('profileSection.accountSecurity') }}</h3>
        <p class="text-sm text-gray-600 dark:text-gray-300 text-center mb-6 leading-relaxed">
            {{ $t('profileSection.managePassword') }}
        </p>

        <button 
            @click="sendResetEmail" 
            :disabled="sending"
            class="inline-flex items-center justify-center px-6 py-3 text-sm font-semibold text-white bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 border-none rounded-xl shadow-sm hover:shadow-md transform hover:-translate-y-0.5 transition-all duration-200 cursor-pointer group disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
        >
            <span v-if="sending">{{ $t('profileSection.sendingResetEmail') }}</span>
            <span v-else>{{ $t('profileSection.sendPasswordResetEmail') }}</span>
            <svg v-if="!sending" class="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
            </svg>
        </button>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import toastStore from '@/store/toast.store'

const sending = ref(false)

const sendResetEmail = async () => {
    sending.value = true
    try {
        const response = await fetch('/api/user/reset-password-email', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        const data = await response.json()
        if (response.ok && !data.error) {
            toastStore.dispatch('addMessage', {
                message: 'Password reset email sent successfully!',
                icon: 'success'
            })
        } else {
            throw new Error(data.message || 'Failed to send reset email')
        }
    } catch (error) {
        toastStore.dispatch('addMessage', {
            message: error.message || 'Failed to send password reset email',
            icon: 'error'
        })
    } finally {
        sending.value = false
    }
}
</script>